import type { Submission } from "../../server/franquicias/leads";
export type { Submission } from "../../server/franquicias/leads";
export class LeadSubmissionError extends Error {
  constructor(public code: string) {
    super(code === "confirmation_pending"
      ? "Estamos verificando la recepción. No envíes otra solicitud; consulta con el equipo."
      : code === "integration_disabled" || code === "configuration_required"
      ? "El formulario todavía no está habilitado para envíos reales."
      : "No se pudo confirmar el envío. Conservamos tus respuestas.");
  }
}
// Separate from the demo payload: no simulated appointment is sent as a real booking.
export async function submitWebLead(lead: Submission, fetcher: typeof fetch = fetch) {
  const response = await fetcher("/api/franquicias/leads", {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify(lead), credentials: "same-origin",
  });
  const result = await response.json();
  if (!response.ok) throw new LeadSubmissionError(result.code || "temporarily_unavailable");
  if (result.status !== "accepted" || result.requestId !== lead.requestId) throw new LeadSubmissionError("invalid_response");
  // Acceptance confirms the form submission, not the asynchronous deal or calendar booking.
  return { status: "accepted" as const, requestId: lead.requestId };
}
